var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisabilityAllowance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_420_2387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7624 7.10038L19.8624 4.2004C18.9026 3.24067 18.9026 1.68013 19.8624 0.720394C20.6451 -0.0646614 21.8307 -0.20811 22.7624 0.290213C23.6932 -0.208055 24.8773 -0.0646614 25.6623 0.720394C26.6221 1.68013 26.6221 3.24067 25.6623 4.2004L22.7624 7.10038Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0977 8.31264C10.288 8.31264 8.81641 6.84102 8.81641 5.03132C8.81641 3.22162 10.288 1.75 12.0977 1.75C13.9074 1.75 15.379 3.22162 15.379 5.03132C15.379 6.84102 13.9074 8.31264 12.0977 8.31264Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3001 28.0008H15.3781V21.4381H11.2764C9.9194 21.4381 8.81546 20.3342 8.81546 18.9771V12.8439C6.07424 12.2464 3.79887 11.1011 1.61914 9.45922L4.54477 5.52502C7.31688 7.55813 9.88052 8.31289 12.0968 8.31289C14.3495 8.31289 16.899 7.5514 19.648 5.52344L22.5744 9.45927C20.3949 11.101 18.1196 12.2463 15.3781 12.844V16.5162H17.8391C19.1961 16.5162 20.3001 17.6201 20.3001 18.9772V28.0008Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7366 23.077H11.2756C9.01404 23.077 7.17393 21.2369 7.17393 18.9753V14.1142C6.96573 14.0529 6.77591 13.9821 6.57613 13.916C4.03201 15.0828 2.25195 17.6386 2.25195 20.6159C2.25195 24.6871 5.56374 27.9989 9.63492 27.9989C11.1521 27.9989 12.5624 27.5369 13.7366 26.7491V23.077Z",
    fill: "#8A8A8A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_420_2387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabilityAllowance);
export default __webpack_public_path__ + "static/media/disability-allowance.b5a09c7bded1c0d159b98b592fbc385b.svg";
export { ForwardRef as ReactComponent };